import Vue from "vue";
import Router from "vue-router";
import Layout from "@/page/index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/index",
      children: [
        {
          path: "index",
          name: "Index",
          component: () => import("@/views/index")
        }
      ]
    },
    {
      path: "/index2",
      component: Layout,
      children: [
        {
          path: "/index2",
          name: "Index2",
          component: () => import("@/views/index2/index")
        }
      ]
    },
    {
      path: "/agreement",
      component: Layout,
      children: [
        {
          path: "/agreement",
          name: "Agreement",
          component: () => import("@/views/agreement/index")
        }
      ]
    },
    {
      path: "/privacy",
      component: Layout,
      children: [
        {
          path: "/privacy",
          name: "Privacy",
          component: () => import("@/views/privacy/index")
        }
      ]
    },
    {
      path: "/notice",
      component: Layout,
      children: [
        {
          path: "/notice",
          name: "Notice",
          component: () => import("@/views/notice/index")
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js